import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider, setLogger } from "react-query";
import { handleError, handleSuccess } from "@vfit/shared/data-access";
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            suspense: false,
            staleTime: 60 * 60 * 1000,
            cacheTime: Infinity,
            onError: function(error) {
                handleError(error);
            },
            onSuccess: function(data) {
                handleSuccess(data);
            }
        },
        mutations: {
            retry: 0
        }
    }
});
setLogger({
    log: console.log,
    warn: console.log,
    error: console.log
});
var QueryProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(QueryClientProvider, {
        client: queryClient,
        children: children
    });
};
export default QueryProvider;
